<script>
  export let label;
  export let checked = false;
  export let value = '';
  export let bindGroup = null;
  export let changeFn = null;

  function onChange(event) {
    const { target } = event;
    const { value, checked } = target;
    if (checked) {
      bindGroup = [...bindGroup, value];
    } else {
      bindGroup = bindGroup.filter((item) => item !== value);
    }
    if (changeFn) {
      changeFn(event);
    }
  }
</script>

{#if bindGroup}
  <label class="check-container"
    >{label}
    <input type="checkbox" checked={bindGroup.includes(value.toString())} {value} on:change={onChange} />
    <span class="checkmark" />
  </label>
{:else}
  <label class="check-container"
    >{label}
    <input type="checkbox" bind:checked on:change={changeFn} {value} />
    <span class="checkmark" />
  </label>
{/if}

<style>
  .check-container {
    min-height: 25px;
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
  }

  /* Hide the browser's default checkbox */
  .check-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: #eee;
    border: 1px solid #000;
  }

  .check-container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  .check-container input:checked ~ .checkmark {
    background-color: #fe5900;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .check-container input:checked ~ .checkmark:after {
    display: block;
  }

  .check-container .checkmark:after {
    left: 9px;
    top: 5px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
</style>
